import { render, staticRenderFns } from "./TagDescription.vue?vue&type=template&id=eed0a0cc&scoped=true&"
import script from "./TagDescription.vue?vue&type=script&lang=js&"
export * from "./TagDescription.vue?vue&type=script&lang=js&"
import style0 from "./TagDescription.vue?vue&type=style&index=0&id=eed0a0cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eed0a0cc",
  null
  
)

export default component.exports